module.exports = __webpack_public_path__ + "static/sauces-f2142fdcd2462614d2cf757d9bd7af42.png";